import { render, staticRenderFns } from "./CheersCard.vue?vue&type=template&id=6c33bff2&"
import script from "./CheersCard.vue?vue&type=script&lang=js&"
export * from "./CheersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports